import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatMenuModule } from '@angular/material/menu';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

import { CrmRoutingModule } from './crm-routing.module';
import { CrmBulkClientsComponent } from './crm-bulk-clients/crm-bulk-clients.component';
import { CrmService } from './services/crm.service';
import { CrmListFeesComponent } from './crm-list-fees/crm-list-fees.component';
import { CrmCreateFeeComponent } from './crm-create-fee/crm-create-fee.component';
import { ClientFormComponent } from './crm-client-form/client-form.component';
import { CrmClientsListComponent } from './crm-list-clients/crm-clients-list.component';
import { ContactListComponent } from './crm-contacts-list/contacts-list.component';
import { BulkCreateFeesComponent } from './crm-bulk-create-fees/bulk-create-fees.component';
import { CreateContactComponent } from './crm-create-contact/create-contact.component';


@NgModule({
  declarations: [
    CrmBulkClientsComponent,
    CrmListFeesComponent,
    CrmCreateFeeComponent,
    ClientFormComponent,
    CrmClientsListComponent,
    ContactListComponent,
    BulkCreateFeesComponent,
    CreateContactComponent,

  ],
  imports: [
    CrmRoutingModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatPaginatorModule,
    MatSelectModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    MatExpansionModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatNativeDateModule,
  ],
  providers: [CrmService],
})
export class CrmModule { }
